/* eslint-disable react/no-direct-mutation-state */
/* eslint-disable react/no-string-refs */
import React, { Component } from "react";
import { animateScroll } from "react-scroll";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import {
  geClientNotes,
  saveClientNote,
  deleteClientNote,
  getAClientNote,
} from "../../Actions/ClientNotes/clientNotesActions.js";
import { checkIfPermissionAllowed, getUser } from "../../Utils/services.js";
import "react-tagsinput/react-tagsinput.css";
import CustomerNote from "./CustomerNote";
import "./client-notes.scss";
import { ConfirmModal } from "../../boxes/ConfirmModal/ConfirmModal.js";
import Loader from "../Common/Loader.js";
import { uiNotification } from "../../services/UINotificationService.js";
import { TextModeToggle } from "../../boxes/TextModeToggle/index.js";
import { MarkdownContent } from "../../shared/MarkdownContent/MarkdownContent.js";
import { PatternAutocomplete } from "../../widgets/PatternAutocomplete/PatternAutocomplete.js";
import { AppTranslation } from "../../i18n/useAppTranslation.js";

const prepareDotPhrases = (dotPhrasesList = []) => {
  return dotPhrasesList.map((i) => ({
    label: i.name,
    description: i?.title || null,
    value: i.phrase,
  }));
};

class ClientNotes extends Component {
  constructor(props) {
    super(props);

    this.escFunction = this.escFunction.bind(this);
    const languageData = JSON.parse(localStorage.getItem("languageData"));

    this.state = {
      backURLType: this.props.match.params.actionType
        ? this.props.match.params.actionType
        : "clients",
      action: this.props.match.params.type
        ? this.props.match.params.type
        : "profile",
      patientID:
        this.props.match.params.patientID !== null &&
        this.props.match.params.patientID !== "" &&
        this.props.match.params.patientID
          ? this.props.match.params.patientID
          : 0,

      showLoader: false,
      customerNotes: [],
      patientData: [],
      customerNote: [],
      showModal: false,
      showTitleModal: false,
      dataChanged: false,
      noteText: "",
      noteTitle: "",
      noteClass: "setting-textarea-box",
      tags: [],
      noteTobeDeleted: 0,
      noteTobeEdited: 0,
      languageData: languageData.procedure,
      globalLang: languageData.global,
      showSearchResult: false,
      caretPos: -1,
    };

    this.contentRef = React.createRef();
  }

  escFunction(event) {
    if (event.keyCode === 27) {
      this.setState({ showSearchResult: false, caretPos: -1 });
    }
  }

  fetchNotesList = () => {
    this.setState({ showLoader: true });

    let formData = {
      params: {
        patient_id: this.state.patientID,
        sortby: "created",
      },
    };
    this.showLoaderFunc();
    this.props.geClientNotes(formData);
  };

  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);
    this.fetchNotesList();
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }

  showLoaderFunc = () => {
    this.setState({ showLoader: true });
    localStorage.setItem("showLoader", true);
  };

  static getDerivedStateFromProps(props, state) {
    if (
      props.customerNotes !== undefined &&
      props.customerNotes.status === 200 &&
      props.customerNotes !== state.customerNotes
    ) {
      if (localStorage.getItem("showLoader") == "false") {
        localStorage.setItem("showLoader", true);

        if (!props.customerNotes.data.patient_detail) {
          setTimeout(function () {
            window.location.href = "/clients";
          }, 0);
        }

        return {
          customerNotes: props.customerNotes.data.patient_notes,
          patientData: props.customerNotes.data.patient_detail,
          showLoader: false,
          dotPhrases: props.customerNotes.data.dot_phrases_list,
          dotPhrasesArr: props.customerNotes.data.dot_phrases_list,
        };
      }
    } else if (
      props.customerNotes !== undefined &&
      props.customerNotes.status !== 200 &&
      props.customerNotes !== state.customerNotes
    ) {
      if (localStorage.getItem("showLoader") == "false") {
        localStorage.setItem("showLoader", true);

        return {
          customerNotes: props.customerNotes.data.patient_notes,
          patientData: props.customerNotes.data.patient_detail,
          showLoader: false,
          dotPhrases: props.customerNotes.data.dot_phrases_list,
          dotPhrasesArr: props.customerNotes.data.dot_phrases_list,
        };
      }
    }

    if (
      props.deleteNoteData !== undefined &&
      props.deleteNoteData.status === 200 &&
      props.deleteNoteData.data !== state.deleteNoteData &&
      state.noteTobeDeleted > 0
    ) {
      return {
        customerNotes: state.customerNotes.filter(
          (noteDetails) => noteDetails.id !== state.noteTobeDeleted,
        ),
        deleteNoteData: props.deleteNoteData.data,
        showLoader: false,
        noteTobeDeleted: 0,
        editNoteID: 0,
      };
    } else if (
      props.deleteNoteData !== undefined &&
      props.deleteNoteData.status !== 200 &&
      props.deleteNoteData.data !== state.deleteNoteData
    ) {
      return {
        deleteNoteData: props.deleteNoteData.data,
        showLoader: false,
      };
    }

    return null;
  }

  getLoggedInUserData = () => {
    let userData = JSON.parse(getUser());

    if (userData) {
      return userData.user.id;
    }

    return 0;
  };

  showDeleteModal = (obj) => {
    this.state.noteTobeDeleted = obj.id;
    this.setState({
      showModal: true,
      showSearchResult: false,
      dataChanged: false,
      noteTobeDeleted: obj.id,
    });
  };

  showTitleModal = () => {
    if (!this.state.noteText) {
      this.setState({
        noteClass: "setting-textarea-box setting-input-box-invalid",
      });
    } else {
      this.setState({ showTitleModal: true });
    }
  };

  editThisNote = (e) => {
    e.preventDefault();
    this.contentRef.current.scrollTo({ top: 0, behavior: "smooth" });
    this.state.noteTobeEdited = e.target.name;
    this.showLoaderFunc();

    if (this.state.noteTobeEdited > 0) {
      this.setState({ showSearchResult: false, dataChanged: false });
      this.props
        .getAClientNote(this.state.noteTobeEdited)
        .then((res) => {
          let hashtags =
            res.data.hashtags &&
            res.data.hashtags !== undefined &&
            res.data.hashtags !== "" &&
            res.data.hashtags !== null
              ? res.data.hashtags.split(",")
              : "";

          let note =
            res.data.notes && res.data.notes !== "" && res.data.notes !== null
              ? res.data.notes
              : "";

          let title =
            res.data.title && res.data.title !== "" && res.data.title !== null
              ? res.data.title
              : "";

          this.setState({
            customerNote: res.data,
            tags: hashtags,
            noteText: note,
            noteTitle: title,
          });
        })
        .catch((res) => {
          uiNotification.error(
            this.state.globalLang[res.message] || "Unable To Retrieve Note",
          );
          this.setState({
            noteTobeEdited: 0,
          });
        })
        .finally(() => {
          this.setState({ showLoader: false });
        });
    }
  };

  dismissDeleteModal = () => {
    this.state.noteTobeDeleted = 0;
    this.setState({ showModal: false, noteTobeDeleted: 0 });
  };

  dismissTitleModal = () => {
    this.setState({ showTitleModal: false });
  };

  deleteNote = () => {
    let noteID = this.state.noteTobeDeleted;
    let patientID = this.state.patientID;

    if (noteID > 0 && patientID > 0) {
      this.showLoaderFunc();
      this.setState({
        tags: [],
        dataChanged: false,
        customerNote: [],
        noteText: "",
        noteClass: "setting-textarea-box",
        showLoader: true,
        showModal: false,
        noteTobeDeleted: noteID,
      });

      this.props
        .deleteClientNote(noteID, patientID)
        .then((res) => {
          uiNotification.success(
            this.state.globalLang[res.message] ||
              "Note Has Been Deleted Successfully",
          );
        })
        .catch((res) => {
          uiNotification.error(
            this.state.globalLang[res.message] || "Unable To Delete Note",
          );
        })
        .finally(() => {
          this.setState({ showLoader: false });
          this.fetchNotesList();
        });

      this.state.customerNote = [];
      this.state.tags = [];
      this.state.noteText = "";
    } else {
      uiNotification.error("Can not delete this note at this time");
    }
  };

  handleSubmit = (event, is_sticky = 0) => {
    event.preventDefault();
    let noteID = this.state.noteTobeEdited;

    const patientNoteText = this.state.noteText.trim();

    if (!patientNoteText) {
      this.setState({
        noteClass: "setting-textarea-box setting-input-box-invalid",
      });
    }
    if (patientNoteText && !this.state.noteTitle.trim() && is_sticky) {
      this.setState({
        noteTitleClass: "setting-textarea-box setting-input-box-invalid",
      });
    } else if (patientNoteText) {
      this.showLoaderFunc();
      this.setState({
        noteClass: "setting-textarea-box",
        noteTitleClass: "",
      });

      const isEditingNoteSticky =
        (!Array.isArray(this.state.customerNote) && this.state.customerNote.id
          ? this.state.customerNote.is_sticky
          : is_sticky) || is_sticky;

      let formData = {
        patient_id: this.state.patientID,
        notes: patientNoteText,
        is_sticky: isEditingNoteSticky,
        sortby: "created",
      };

      if (is_sticky) {
        formData["title"] = this.state.noteTitle;
      }

      let titleRef = this.refs.noteTitle;

      if (this.state.tags && this.state.tags.length > 0) {
        formData.tags = this.state.tags;
      }

      this.props
        .saveClientNote({ formData, noteID })
        .then((res) => {
          uiNotification.success(
            this.state.globalLang[res.message] || "Note Saved Successfully",
          );

          if (is_sticky) {
            titleRef.value = "";
          }

          this.setState({
            tags: [],
            showTitleModal: false,
            dataChanged: false,
            customerNote: [],
            noteText: "",
            noteTobeEdited: 0,
            noteTitle: "",
          });
        })
        .catch((res) => {
          uiNotification.error(
            this.state.globalLang[res.message] ||
              res.message ||
              "Unable To Save Note",
          );
        })
        .finally(() => this.setState({ showLoader: false }));
    }
  };

  handleChange = (value) => {
    this.setState({ tags: value, dataChanged: true });
  };

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    let filteredArray = [];

    let strValue = value.substring(0, event.target.selectionStart);
    let strArray = strValue.split(".");
    let strToCheck = "";
    strToCheck = "." + strArray[strArray.length - 1];

    if (
      event.target.name === "noteText" &&
      strToCheck.length > 0 &&
      strValue.lastIndexOf(".") !== -1 &&
      strToCheck.lastIndexOf(".") !== -1 &&
      strToCheck.indexOf(" ", strToCheck.lastIndexOf(".") + 1) === -1
    ) {
      if (this.state.dotPhrases && this.state.dotPhrases.length > 0) {
        this.state.dotPhrases.map((obj) => {
          let name = obj.name.toLowerCase();
          let needle = strToCheck.toLowerCase();
          needle = needle.substr(1);

          if (name.includes(needle) || name === needle) {
            let filterObj = {};

            filterObj.id = obj.id;
            filterObj.name = obj.name;
            filterObj.title = obj.title;
            filterObj.phrase = obj.phrase;

            filteredArray.push(filterObj);
          }
        });
      }

      this.setState(
        {
          [event.target.name]: value,
          dataChanged: true,
          showSearchResult: true,
          caretPos: event.target.selectionStart,
          dotPhrasesArr: filteredArray,
        },
        this.scrollToTop,
      );
    } else {
      this.setState({
        [event.target.name]: value,
        dataChanged: true,
        showSearchResult: false,
        caretPos: -1,
      });
    }
  };

  scrollToTop() {
    animateScroll.scrollToTop({
      containerId: "dotPhraseList",
      duration: 10,
      delay: 10,
    });
  }

  cancelEditing = (event) => {
    event.preventDefault();

    this.state.customerNote = [];
    this.state.tags = [];
    this.state.noteText = "";

    this.setState({
      tags: [],
      dataChanged: false,
      customerNote: [],
      noteText: "",
      noteTitle: "",
      noteTobeEdited: 0,
      noteClass: "setting-textarea-box",
    });
  };

  selectPhrase = (obj) => {
    let noteText = this.state.noteText;
    let phrase = obj.phrase;
    let position = this.state.caretPos;

    let strValue = noteText.substring(0, position);
    let strArray = strValue.split(".");
    let deduction = strArray[strArray.length - 1];
    deduction = deduction.length + 1;
    let output = [
      noteText.slice(0, position - deduction),
      phrase,
      noteText.slice(position),
    ].join("");

    this.setState({ noteText: output, showSearchResult: false, caretPos: -1 });

    document.getElementById("notes").focus();
  };

  setNotesList = (updatedDetails) => this.setState(updatedDetails);

  openStickyTitleModal = (event) => {
    const patientNoteText = this.state.noteText.trim();

    if (!patientNoteText) {
      this.setState({
        noteClass: "setting-textarea-box setting-input-box-invalid",
      });
    } else {
      this.setState({
        noteClass: "setting-textarea-box",
      });
      event.preventDefault();
      this.showTitleModal();
    }
  };

  render() {
    let returnUrl = "";

    if (this.state.backURLType && this.state.backURLType === "clients") {
      returnUrl = this.props.match.params.type
        ? "/" +
          this.state.backURLType +
          "/" +
          this.props.match.params.type +
          "/" +
          this.props.match.params.patientID +
          "/1"
        : "/" + this.state.backURLType;
    }

    let noteTimelineClass =
      this.state.customerNotes &&
      this.state.customerNotes.length > 0 &&
      checkIfPermissionAllowed("view-customer-notes")
        ? "note-timeline can-see displayBlock"
        : "note-timeline no-display";

    let noRecordClass =
      this.state.customerNotes && this.state.customerNotes.length > 0
        ? "no-record no-display"
        : "no-record";

    let firstname =
      this.state.patientData && this.state.patientData.firstname
        ? this.state.patientData.firstname
        : "";
    let lastname =
      this.state.patientData && this.state.patientData.lastname
        ? this.state.patientData.lastname
        : "";

    let patientName = firstname + " " + lastname;

    return (
      <div id="content">
        <div ref={this.contentRef} className="wide-popup">
          <div className="modal-blue-header">
            <Link to={returnUrl} className="popup-cross">
              ×
            </Link>
            {this.state.showLoader === false && (
              <span className="popup-blue-name">
                {patientName +
                  ` - ${this.state.languageData.cus_head_cus_notes_text}`}
              </span>
            )}
          </div>
          <div className="wide-popup-wrapper time-line displayBlock client-notes-container">
            {checkIfPermissionAllowed("add-update-customer-notes") && (
              <div>
                <div className="juvly-subtitle">
                  {this.state.languageData.pro_add_note_text}
                </div>
                <div className="row">
                  <div className="col-xs-12">
                    <form
                      id="add-notes"
                      name="ar-add-notes-form"
                      className="nobottommargin"
                      action="#"
                      method="post"
                    >
                      <div className="row">
                        <div className="col-xs-12">
                          <div className="new-field-label">
                            {this.state.languageData.pro_note_text}{" "}
                            <span className="setting-require">*</span>
                          </div>
                          <TextModeToggle
                            toggleOnPreviewClick
                            renderPreviewMode={() => (
                              <MarkdownContent>
                                {this.state.noteText}
                              </MarkdownContent>
                            )}
                            renderEditMode={() => (
                              <PatternAutocomplete
                                focusOnMount
                                value={this.state.noteText || ""}
                                onChange={(next) => {
                                  this.setState({ noteText: next });
                                }}
                                placeholder="Type your notes and hashtags here"
                                patterns={[
                                  {
                                    match: ".",
                                    substitutes: prepareDotPhrases(
                                      this.state.dotPhrasesArr,
                                    ),
                                  },
                                ]}
                              />
                            )}
                          />
                          <div className="m-t-5 m-b-10 maxCharacterInstruction">
                            <AppTranslation.Clients path="createEditHealthProcedure.notes.dotPhrasesDesc" />
                          </div>
                        </div>
                        <div className="col-xs-12">
                          <input
                            onClick={this.handleSubmit}
                            className="new-blue-btn pull-left no-margin"
                            value={this.state.languageData.pro_save_btn_text}
                            type="submit"
                            id="save-profile"
                          />

                          {!(
                            this.state.noteTobeEdited &&
                            this.state.customerNote.is_sticky
                          ) && (
                            <input
                              onClick={this.openStickyTitleModal}
                              className="save-sticky-note-button"
                              value="Save as Sticky Note"
                              type="button"
                              id="save-sticky-note"
                            />
                          )}

                          {this.state.noteTobeEdited &&
                          this.state.noteTobeEdited > 0 ? (
                            <input
                              onClick={this.cancelEditing}
                              className="new-red-btn  no-margin note-cancel-button"
                              value="Cancel"
                              type="button"
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            )}
            {this.state.showModal && (
              <ConfirmModal
                isOpen
                onConfirm={this.deleteNote}
                onCancel={this.dismissDeleteModal}
                onClose={this.dismissDeleteModal}
                className="confirm-modal-center"
              >
                {this.state.languageData.pro_are_you_sure_text}
              </ConfirmModal>
            )}
            {this.state.showTitleModal && (
              <ConfirmModal
                title="Add Sticky Note Title"
                isOpen
                onConfirm={(event) => this.handleSubmit(event, 1)}
                onClose={this.dismissTitleModal}
                className="confirm-modal-center sticky-note-add-title-modal"
                footerClassName={"sticky-note-add-title-modal-footer"}
                confirmTitle="Save Sticky Note"
              >
                <textarea
                  placeholder="Type Notes Title here..."
                  ref="noteTitle"
                  id="noteTitle"
                  style={{ overFlow: "" }}
                  className={`setting-textarea-box ${this.state.noteTitleClass} `}
                  name="noteTitle"
                  onChange={this.handleInputChange}
                  value={this.state.noteTitle}
                ></textarea>
                {this.state.showLoader === true && <Loader showLoader />}
              </ConfirmModal>
            )}

            {this.state.showLoader === false && (
              <div className={noRecordClass}>
                {this.state.languageData.pro_no_notes_text}
              </div>
            )}
            {this.state.showLoader === true && (
              <div className="no-record">
                {this.state.languageData.pro_loading_dot}
              </div>
            )}
            <div className={noteTimelineClass}>
              {checkIfPermissionAllowed("view-customer-notes") &&
                this.state.customerNotes !== undefined &&
                this.state.customerNotes.map((noteobj, noteidx) => {
                  return (
                    <CustomerNote
                      noteobj={noteobj}
                      languageData={this.state.languageData}
                      globalLang={this.state.globalLang}
                      noteidx={noteidx}
                      noteToShow={noteobj.notes}
                      showDeleteModal={this.showDeleteModal}
                      getLoggedInUserData={this.getLoggedInUserData}
                      editThisNote={this.editThisNote.bind(this)}
                      key={noteidx.id}
                      fetchNotesList={this.fetchNotesList}
                      updateNotesList={this.setNotesList}
                    />
                  );
                })}
            </div>
          </div>
          <div
            className={
              this.state.showLoader
                ? "new-loader text-left displayBlock"
                : "new-loader text-left"
            }
          >
            <div className="loader-outer">
              <img
                alt=""
                id="loader-outer"
                src="/images/Eclipse.gif"
                className="loader-img"
              />
              <div id="modal-confirm-text" className="popup-subtitle">
                {this.state.globalLang.Please_Wait}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  localStorage.setItem("showLoader", false);

  if (state.ClientNotesReducer.action === "GET_CLIENT_NOTES") {
    return {
      customerNotes: state.ClientNotesReducer.data,
    };
  }

  if (
    state.ClientNotesReducer.action === "SAVE_CLIENT_NOTES" &&
    state.ClientNotesReducer.data.status === 201
  ) {
    return {
      customerNotes: state.ClientNotesReducer.data,
    };
  }

  if (state.ClientNotesReducer.action === "DELETE_CLIENT_NOTE") {
    return {
      deleteNoteData: state.ClientNotesReducer.data,
    };
  }

  if (
    state.ClientNotesReducer.action === "UPDATE_CLIENT_NOTE" &&
    state.ClientNotesReducer.data.status === 201
  ) {
    return {
      customerNotes: state.ClientNotesReducer.data,
    };
  }

  return {};
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      geClientNotes,
      saveClientNote,
      deleteClientNote,
      getAClientNote,
    },
    dispatch,
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(ClientNotes));
